import { Moment } from 'moment';

export const renderMonthText = (month: Moment) => month.format('MMMM - YYYY');

export const MIN_WIDTH_FORM = 220;
